import { render, staticRenderFns } from "./ModalBoleta.vue?vue&type=template&id=0445ae12"
import script from "./ModalBoleta.vue?vue&type=script&lang=js"
export * from "./ModalBoleta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports